module.exports = __webpack_public_path__ + "static/media/6_pol_0_83.8.d0901995.png";